var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-outline_Edit_Square",
    "data-name": "Iconly/Light-outline/Edit Square",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit_Square",
    "data-name": "Edit Square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Edit_Square-2",
    "data-name": "Edit Square",
    d: "M4.809,17A4.645,4.645,0,0,1,0,12.186l0-.2V5.047A4.667,4.667,0,0,1,4.614.035l.2,0H7.935A.626.626,0,0,1,8.02,1.278l-.085.005H4.809A3.4,3.4,0,0,0,1.258,4.848l0,.2v6.939a3.418,3.418,0,0,0,3.365,3.759l.19,0h7.376a3.4,3.4,0,0,0,3.553-3.563l0-.2V8.624a.627.627,0,0,1,1.248-.085L17,8.624v3.361A4.663,4.663,0,0,1,12.381,17l-.2,0ZM5.1,12.46a.627.627,0,0,1-.627-.642L4.55,8.664A2.427,2.427,0,0,1,5.264,7L11.511.765a2.624,2.624,0,0,1,3.7,0l1.017,1.016a2.612,2.612,0,0,1,0,3.7L9.956,11.746a2.428,2.428,0,0,1-1.727.715ZM6.151,7.887A1.18,1.18,0,0,0,5.8,8.7L5.74,11.207H8.229a1.2,1.2,0,0,0,.753-.269l.087-.079,4.876-4.869L11,3.049Zm8.681-2.78.514-.513a1.361,1.361,0,0,0,0-1.928L14.329,1.651a1.368,1.368,0,0,0-1.932,0l-.513.513Z",
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.9db6bd19389a5ac143b3b8ae70f59784.svg";
export { ForwardRef as ReactComponent };